import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { myListingsIconUrl } from '../../../utils/staticAssets'

const STATUS_CLASSES = {
  published: 'bg-sage-60',
  'listing-approved': 'bg-sage-60',
  'on-hold': 'bg-warning text-white',
  sponsored: 'bg-punch-lime',
  sold: 'bg-white border border-midnight-black-10',
  'auto-marked-as-sold': 'bg-white border border-midnight-black-10',
  cancelled: 'bg-white border border-midnight-black-10',
  'auto-marked-as-stale': 'bg-[#F7E1DC]', // terracotta-20 (not in tailwind theme)
  'awaiting-approval': 'bg-midnight-black-10',
  draft: 'bg-midnight-black-10',
  'listing-under-creation': 'bg-midnight-black-10',
  'action-required': 'bg-punch-lime-60',
  'listing-created-and-under-review': 'bg-punch-lime-60',
  rejected: 'bg-chalky-pink',
  disapproved: 'bg-chalky-pink'
}

class StatusTag extends Component {
  render () {
    if (this.props.content) {
      const status = this.props.content.toLowerCase().replace(/ /g, '-')
      const colourClasses = STATUS_CLASSES[status] || ''
      return (
        <div className={`status-tag w-fit py-2 px-10 rounded-xl ${colourClasses} ${this.props.className || ''}`}>
          {status === 'sponsored'
            ? <img width='12' style={{ marginRight: '6px', display: 'inline-block', position: 'relative', top: '-2px' }} src={myListingsIconUrl('boost_listing.svg')} />
            : null}
          {this.props.content}
        </div>
      )
    } else {
      return (
        <div />
      )
    }
  }
}

StatusTag.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string
}

export default StatusTag
